// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeepWorkKipsChart__sparkline____ij13 {
    margin: 6px 15px 10px 15px;
}

.DeepWorkKipsChart__stars___T4LaF {
    padding-left: 10px;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sparkline": `DeepWorkKipsChart__sparkline____ij13`,
	"stars": `DeepWorkKipsChart__stars___T4LaF`
};
module.exports = ___CSS_LOADER_EXPORT___;
